{
  "AGENT_BOTS": {
    "HEADER": "Bots",
    "LOADING_EDITOR": "Loading editor...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try.You can manage your bots from this page or create new ones using the 'Configure new bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "GLOBAL_BOT_BADGE": "Σύστημα",
    "AVATAR": {
      "SUCCESS_DELETE": "Το avatar του bot διαγράφηκε επιτυχώς",
      "ERROR_DELETE": "Σφάλμα κατά τη διαγραφή του avatar του bot, παρακαλώ προσπαθήστε ξανά"
    },
    "CSML_BOT_EDITOR": {
      "NAME": {
        "LABEL": "Bot name",
        "PLACEHOLDER": "Name your bot.",
        "ERROR": "Το Όνομα Bot είναι απαραίτητο."
      },
      "DESCRIPTION": {
        "LABEL": "Bot description",
        "PLACEHOLDER": "Τι κάνει αυτό το bot?"
      },
      "BOT_CONFIG": {
        "ERROR": "Παρακαλώ εισάγετε την διαμόρφωση του CSML bot παραπάνω.",
        "API_ERROR": "Your CSML configuration is invalid. Please fix it and try again."
      },
      "SUBMIT": "Επαλήθευση και αποθήκευση"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Επιλέξτε ενός Agent Bot",
      "DESC": "Assign an Agent Bot to your inbox. They can handle initial conversations and transfer them to a live agent when necessary.",
      "OPTION": "{name} ({description})",
      "SUBMIT": "Ενημέρωση",
      "DISCONNECT": "Disconnect bot",
      "SUCCESS_MESSAGE": "Επιτυχής ενημέρωση του agent bot.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Successfully disconnected the agent bot.",
      "ERROR_MESSAGE": "Could not update the agent bot. Please try again.",
      "DISCONNECTED_ERROR_MESSAGE": "Could not disconnect the agent bot. Please try again.",
      "SELECT_PLACEHOLDER": "Select bot",
      "COUNTRY_BOTS": {
        "TITLE": "Bots ανά χώρα",
        "DESC": "Αυτό το inbox εξυπηρετεί περισσότερες χώρες. Μια συνομιλία πηγαίνει στο bot της χώρας της: ανάλογα με το κατάστημα του Kaufland, την αγορά της παραγγελίας του Allegro ή, διαφορετικά, τη γλώσσα στην οποία γράφει ο πελάτης. Όλες οι άλλες συνομιλίες πηγαίνουν στο προεπιλεγμένο bot παραπάνω.",
        "COUNTRY": "Επιλέξτε χώρα",
        "BOT": "Επιλέξτε bot",
        "ADD": "Προσθήκη bot για χώρα",
        "REMOVE": "Αφαίρεση",
        "DEFAULT_REQUIRED": "Επιλέξτε πρώτα ένα προεπιλεγμένο bot. Το bot μιας χώρας το αντικαθιστά μόνο για τη χώρα αυτή.",
        "DISCONNECT_ALL": "Αποσύνδεση όλων των bots"
      }
    },
    "ADD": {
      "TITLE": "Ρύθμιση νέου bot",
      "CANCEL_BUTTON_TEXT": "Άκυρο",
      "API": {
        "SUCCESS_MESSAGE": "Το bot προστέθηκε επιτυχώς.",
        "ERROR_MESSAGE": "Could not add bot. Please try again later."
      }
    },
    "LIST": {
      "404": "No bots found. You can create a bot by clicking the 'Configure new bot' button ↗",
      "LOADING": "Fetching bots...",
      "TABLE_HEADER": {
        "DETAILS": "Λεπτομέρειες Bot",
        "URL": "Webhook URL"
      },
      "TYPE": "Bot type"
    },
    "DELETE": {
      "BUTTON_TEXT": "Διαγραφή",
      "TITLE": "Delete bot",
      "CONFIRM": {
        "TITLE": "Επιβεβαίωση Διαγραφής",
        "MESSAGE": "Είσαστε σίγουροι ότι θέλετε να διαγράψετε το {name};",
        "YES": "Ναι, Διαγραφή",
        "NO": "Όχι, Διατήρηση"
      },
      "SUBMIT": "Διαγραφή",
      "CANCEL_BUTTON_TEXT": "Άκυρο",
      "DESCRIPTION": "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το bot? Αυτή η ενέργεια είναι μη αναστρέψιμη.",
      "API": {
        "SUCCESS_MESSAGE": "Το bot διαγράφηκε επιτυχώς.",
        "ERROR_MESSAGE": "Could not delete bot. Please try again."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Επεξεργασία",
      "LOADING": "Fetching bots...",
      "TITLE": "Edit bot",
      "CANCEL_BUTTON_TEXT": "Άκυρο",
      "API": {
        "SUCCESS_MESSAGE": "Το bot ενημερώθηκε επιτυχώς.",
        "ERROR_MESSAGE": "Could not update bot. Please try again."
      }
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Avatar Bot"
      },
      "NAME": {
        "LABEL": "Όνομα Bot",
        "PLACEHOLDER": "Εισάγετε το όνομα του bot"
      },
      "DESCRIPTION": {
        "LABEL": "Περιγραφή",
        "PLACEHOLDER": "Τι κάνει αυτό το bot;"
      },
      "WEBHOOK_URL": {
        "LABEL": "Webhook URL",
        "PLACEHOLDER": "https://example.com/webhook"
      },
      "ERRORS": {
        "NAME": "Το όνομα του bot είναι απαραίτητο",
        "URL": "Το Webhook URL είναι απαραίτητο",
        "VALID_URL": "Παρακαλώ εισάγετε ένα έγκυρο URL που να ξεκινάει με http:// ή https://"
      },
      "CANCEL": "Άκυρο",
      "CREATE": "Δημιουργία Bot",
      "UPDATE": "Ενημέρωση Bot"
    },
    "TYPES": {
      "WEBHOOK": "Webhook bot",
      "CSML": "CSML bot"
    }
  }
}
